import { AuthConfig, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { Environment } from '../types';

// ## angular-oauth2-oidc CONFIGURATION ##
export const getAuthConfig = (environment: Environment, baseHref: string): AuthConfig => ({
  issuer: `https://cognito-idp.${environment.region}.amazonaws.com/${environment.userPoolId}`,
  clientId: environment.cognitoClientId,
  redirectUri: `${window.location.origin}${baseHref}callback`, // must match Cognito App Client settings
  decreaseExpirationBySec: 600000, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/1135
  timeoutFactor: 0.75,
  responseType: 'code',
  scope: 'email openid phone',
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: false,
});

// configuration for the auth provider interceptor (to include token in requests)
export const getOauthModuleConfig = (environment: Environment): OAuthModuleConfig => ({
  resourceServer: {
    allowedUrls: environment.backendUrl ? [environment.backendUrl] : [],
    sendAccessToken: true,
  },
});

// ## COGNITO ##
export const getLogoutUrl = (environment: Environment, baseHref: string) => {
  const logoutEndpoint = `${environment.userPoolUrl}/logout?`;
  const homeUrl = `${window.location.origin}${baseHref}`;
  const logoutParams = `client_id=${environment.cognitoClientId}&logout_uri=${homeUrl}`;
  return `${logoutEndpoint}${logoutParams}`;
};
